import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=02903bf5&scoped=true&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"
import style0 from "./test1.vue?vue&type=style&index=0&id=02903bf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02903bf5",
  null
  
)

export default component.exports